// SharedPrefs
//
// Convenience wrapper for AveoSharedPreferences plugin.

'use strict';

var log = require('../../log/Log').channel('SharedPrefs');

/* global AveoSharedPreferences */

angular.module('inara').factory('SharedPrefs', SharedPrefs);

SharedPrefs.$inject = [ '$q' ];

function SharedPrefs($q) {
    var isReady = false;
    var readyPromises = [];

    documentLoaded()
    .then(deviceReady)
    .then(setSharedPrefsReady);

	return {
		getBoolean: getBoolean,
        getFloat: getFloat,
		getInt: getInt,
        getLong: getLong,
		getString: getString,
        getStringSet: getStringSet,
		setBoolean: setBoolean,
        setFloat: setFloat,
		setInt: setInt,
        setLong: setLong,
		setString: setString,
        setStringSet: setStringSet,
	};

    function documentLoaded() {
        return $q(function(resolve, reject) {
            if (document.readyState === 'complete') {
                resolve();
            } else {
                window.addEventListener('load', function() {
                    resolve();
                });
            }
        });
    }

    function deviceReady() {
        return $q(function(resolve, reject) {
            document.addEventListener('deviceready', function() {
                resolve();
            });
        });
    }

    function setSharedPrefsReady() {
        isReady = true;

        for (var i = 0; i < readyPromises.length; i++) {
            readyPromises[i].resolve();
        }

        readyPromises.length = 0;
    }

    function sharedPrefsReady() {
        if (isReady) return $q.resolve();

        var deferredPromise = $q.defer();
        readyPromises.push(deferredPromise);
        return deferredPromise.promise;
    }

    function getBoolean(key, defaultValue, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.getBoolean(key, defaultValue, function(value) {
                resolve(value);
            }, function() {
            	var err = new Error('failed getting ' + key +
            		' from shared preferences');
            	log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

    function getFloat(key, defaultValue, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.getFloat(key, defaultValue, function(value) {
                resolve(value);
            }, function() {
                var err = new Error('failed getting ' + key +
                    ' from shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

    function getInt(key, defaultValue, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.getInt(key, defaultValue, function(value) {
                resolve(value);
            }, function() {
                var err = new Error('failed getting ' + key +
                	' from shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

    function getLong(key, defaultValue, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.getLong(key, defaultValue, function(value) {
                resolve(value);
            }, function() {
                var err = new Error('failed getting ' + key +
                    ' from shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

	function getString(key, defaultValue, packageName, prefsFileName) {
        return sharedPrefsReady()
	    .then(function() { return $q(function(resolve, reject) {
	        AveoSharedPreferences.getString(key, defaultValue, function(value) {
	            resolve(value);
	        }, function() {
	            var err = new Error('failed getting ' + key +
	            	' from shared preferences');
	            log.error(err.message);
	            reject(err);
	        }, packageName, prefsFileName);
	    });});
	}

    function getStringSet(key, defaultValue, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.getStringSet(key, defaultValue, function(value) {
                resolve(value);
            }, function() {
                var err = new Error('failed getting ' + key +
                    ' from shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }
	
    function setBoolean(key, value, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.setBoolean(key, value, function() {
                log.debug('wrote ' + key + ' = ' + value +
                          ' to shared preferences');
                resolve(value);
            }, function() {
                var err = new Error('failed writing ' + key + ' = ' + value +
                	' to shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

    function setFloat(key, value, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.setFloat(key, value, function() {
                log.debug('wrote ' + key + ' = ' + value +
                          ' to shared preferences');
                resolve(value);
            }, function() {
                var err = new Error('failed writing ' + key + ' = ' + value +
                    ' to shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

    function setInt(key, value, packageName, prefsFileName) {
        return sharedPrefsReady()
       .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.setInt(key, value, function() {
                log.debug('wrote ' + key + ' = ' + value +
                          ' to shared preferences');
                resolve(value);
            }, function() {
                var err = new Error('failed writing ' + key + ' = ' + value +
                	' to shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

    function setLong(key, value, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.setLong(key, value, function() {
                log.debug('wrote ' + key + ' = ' + value +
                          ' to shared preferences');
                resolve(value);
            }, function() {
                var err = new Error('failed writing ' + key + ' = ' + value +
                    ' to shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }

	function setString(key, value, packageName, prefsFileName) {
        return sharedPrefsReady()
		.then(function() { return $q(function(resolve, reject) {
			AveoSharedPreferences.setString(key, value, function() {
				log.debug('wrote ' + key + ' = ' + value + ' to shared preferences');
				resolve();
			}, function() {
				var err = new Error('failed writing ' + key + ' = ' + value +
					' to shared preferences');
				log.error(err.message);
				reject(err);
			}, packageName, prefsFileName);
		});});
	}

    function setStringSet(key, value, packageName, prefsFileName) {
        return sharedPrefsReady()
        .then(function() { return $q(function(resolve, reject) {
            AveoSharedPreferences.setStringSet(key, value, function() {
                log.debug('wrote ' + key + ' = ' + value +
                          ' to shared preferences');
                resolve(value);
            }, function() {
                var err = new Error('failed writing ' + key + ' = ' + value +
                    ' to shared preferences');
                log.error(err.message);
                reject(err);
            }, packageName, prefsFileName);
        });});
    }
}

module.exports = SharedPrefs;

